import { withTranslation } from "next-i18next";
import useResponsive from "@helpers/useResponsive";
import Desktop from "./lib/Desktop";
import Mobile from "./lib/Mobile";
import type { TProductData } from "./type";

const InterestFormLevelOne: React.FC<TProductData> = (props) => {
  const isMobile = useResponsive("md");
  const Component = isMobile ? Mobile : Desktop;
  return <Component {...props} />;
};

export default withTranslation("common")(InterestFormLevelOne);
